import { API } from '@aws-amplify/api';
import { SurveyStatusResponse } from '../../@types/subjectSurvey';

export interface GetSubjectSurveyStatusInput {
  studentId: string;
  subjects: string[];
}

export async function getSubjectSurveyStatus(
  input: GetSubjectSurveyStatusInput
): Promise<SurveyStatusResponse> {
  try {
    const apiName = process.env.NEXT_PUBLIC_ONBOARDING_API_NAME!;
    const path = 'api/subject-survey/status';
    const myInit = {
      headers: {},
      queryStringParameters: {
        studentId: input.studentId,
        subjects: input.subjects.join(','),
      },
    };

    const response = await API.get(apiName, path, myInit);
    return response;
  } catch (error) {
    console.error('Error getting subject survey status:', error);
    throw error;
  }
}
